import * as React from "react";
import type { SVGProps } from "react";
const SvgIconBarView = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" height="24px" width="24px" viewBox="0 0 46 46" {...props}><path d="M8 40V18h7v22Zm12.5 0V8h7v32ZM33 40V26h7v14Z" /></svg>;
export default SvgIconBarView;